import { render, staticRenderFns } from "./InterestedProduct.vue?vue&type=template&id=cf454f18"
import script from "./InterestedProduct.vue?vue&type=script&lang=js"
export * from "./InterestedProduct.vue?vue&type=script&lang=js"
import style0 from "./InterestedProduct.vue?vue&type=style&index=0&id=cf454f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports